import { useState } from "react";
import { toast } from "sonner";
import { Building2, Landmark, Phone, User, Info, CircleCheck, Loader2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageHeader, Panel } from "@/components/Shared";

const fmtCnpj = (v) => v.replace(/\D/g, "").slice(0, 14).replace(/^(\d{2})(\d)/, "$1.$2").replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3").replace(/\.(\d{3})(\d)/, ".$1/$2").replace(/(\d{4})(\d)/, "$1-$2");
const fmtPhone = (v) => v.replace(/\D/g, "").slice(0, 11).replace(/^(\d{2})(\d)/, "($1) $2").replace(/(\d{5})(\d)/, "$1-$2");

const IconInput = ({ icon: Icon, label, testid, ...p }) => (
  <label className="block">
    <span className="mb-1.5 block text-xs font-semibold text-slate-900">{label}</span>
    <span className="relative block"><Icon className="absolute left-3.5 top-3.5 h-4 w-4 text-slate-400" />
      <input data-testid={testid} className="h-11 w-full rounded-xl border border-slate-200 bg-[#FDFCF8] pl-10 pr-3 text-slate-900 outline-none transition-colors focus:border-amber-400 focus:ring-2 focus:ring-amber-100" {...p} /></span>
  </label>
);

export default function RestaurantProfile() {
  const { user, refresh } = useAuth();
  const [f, setF] = useState({ restaurant_name: user.restaurant_name || "", cnpj: user.cnpj || "", phone: user.phone || "", responsible: user.responsible || user.name || "" });
  const [busy, setBusy] = useState(false);
  const save = async (e) => {
    e.preventDefault(); setBusy(true);
    try { await api.put("/me/profile", f); await refresh(); toast.success("Dados salvos"); } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  return (
    <div className="fade-up">
      <PageHeader eyebrow="Conta e perfil" title="Dados do restaurante" />
      <Panel title="Perfil do restaurante" sub="Esses dados ajudam a identificar seus recursos." icon={Building2} className="max-w-2xl">
        <form onSubmit={save} className="space-y-5 border-t border-slate-100 pt-5">
          <div className="grid gap-4 sm:grid-cols-2">
            <IconInput icon={Building2} label="Nome do restaurante" testid="profile-name-input" value={f.restaurant_name} onChange={(e) => setF({ ...f, restaurant_name: e.target.value })} placeholder="Ex.: Brasa & Ponto" />
            <IconInput icon={Landmark} label="CNPJ" testid="profile-cnpj-input" value={f.cnpj} onChange={(e) => setF({ ...f, cnpj: fmtCnpj(e.target.value) })} placeholder="00.000.000/0000-00" />
            <IconInput icon={Phone} label="Telefone de contato" testid="profile-phone-input" value={f.phone} onChange={(e) => setF({ ...f, phone: fmtPhone(e.target.value) })} placeholder="(11) 90000-0000" />
            <IconInput icon={User} label="Responsável pelo acesso" testid="profile-responsible-input" value={f.responsible} onChange={(e) => setF({ ...f, responsible: e.target.value })} />
          </div>
          <p className="flex gap-2 rounded-xl bg-slate-50 p-3 text-[11px] text-slate-500"><Info className="h-3.5 w-3.5 shrink-0" /> Acesso: {user.email}. Seus dados ficam visíveis apenas para sua conta, conforme a LGPD.</p>
          <button data-testid="profile-save-btn" disabled={busy} className="inline-flex h-11 items-center gap-2 rounded-xl bg-slate-900 px-5 text-[15px] font-medium text-white hover:bg-slate-800 disabled:opacity-60">{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <CircleCheck className="h-4 w-4" />} Salvar dados</button>
        </form>
      </Panel>
    </div>
  );
}
